import { ApiSlugs, ListPagination, UserHistoryDto, UserHistoryId } from '@workspace/data-types';
import { Observable } from 'rxjs';
import { ApiCaller } from '../../../../../api-caller.service';
import { ApiConnector } from '../../../../../api-connector.abstract-service';
import { QueryParamsUtils } from '../../../../../utils/query-params.utils';

export class UserHistoryAdminConnector extends ApiConnector<UserHistoryDto, UserHistoryDto, UserHistoryId> {
  constructor(apiCaller: ApiCaller, userUrl: string, apiPrefix: string) {
    super(apiCaller, apiPrefix, `${userUrl}/${ApiSlugs.HISTORY}`);
  }

  summerized = () => ({
    list: (pagination?: ListPagination): Observable<UserHistoryDto[]> =>
      this.apiCaller.getRequest<UserHistoryDto[]>(
        this.apiPrefix,
        `${this.slug}/all${QueryParamsUtils.buildFilterParams(pagination)}`,
      ),
    count: (pagination?: ListPagination): Observable<number> =>
      this.apiCaller.getRequest<number>(
        this.apiPrefix,
        `${this.slug}/all/count${QueryParamsUtils.buildFilterParams(pagination, true)}`,
      ),
  });
}
